// extracted by mini-css-extract-plugin
export default {"RegenerateButton":"O0gXyDpkXanuZxPeHTaa","RegenerateButtonContainer":"AS39I0bSbtDx3xDBtwl0"};